import React from 'react';

export const WaterAnimation = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Animated water droplets */}
      <div className="absolute top-1/4 left-1/4 w-32 h-32 rounded-full bg-gradient-to-br from-primary/5 to-accent/10 blur-3xl animate-float" style={{ animationDelay: '0s' }}></div>
      <div className="absolute top-1/3 right-1/4 w-40 h-40 rounded-full bg-gradient-to-br from-accent/5 to-secondary/10 blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>
      <div className="absolute bottom-1/4 left-1/3 w-36 h-36 rounded-full bg-gradient-to-br from-secondary/5 to-primary/10 blur-3xl animate-float" style={{ animationDelay: '2s' }}></div>
      
      {/* Ripple effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <div className="w-96 h-96 rounded-full border-2 border-accent/10 animate-ripple" style={{ animationDelay: '0s' }}></div>
        <div className="w-96 h-96 rounded-full border-2 border-primary/10 animate-ripple absolute inset-0" style={{ animationDelay: '0.5s' }}></div>
        <div className="w-96 h-96 rounded-full border-2 border-secondary/10 animate-ripple absolute inset-0" style={{ animationDelay: '1s' }}></div>
      </div>
    </div>
  );
};

export default WaterAnimation;
